import { selectors, useDispatch, useSelector } from '@sloyd/store-base';
import { useMemo } from 'react';
import { useMount } from 'react-use';
import { $a, invokeEvent } from 'shared-base';
import { ContentGoldens } from './ContentGoldens';

export type ContentGoldensContainerProps = {};

export function ContentGoldensContainer(_props: ContentGoldensContainerProps) {
  const dispatch = useDispatch();
  const generatorsWithGoldens = useSelector(selectors.base.$generatorsWithGoldens);
  const adminGoldensStats = useSelector(selectors.base.$adminGoldensStats);

  useMount(() => {
    setTimeout(() => {
      dispatch($a('GOLDEN', 'fetchAll'));
    }, 200);
  });

  const callbacks = useMemo(
    () => ({
      onOpenGenerator: (id: string) => {
        invokeEvent('nav', { path: `/playground/generators/${id}` });
      },
      onManageGolden: (id: string) => {
        dispatch($a('GOLDEN', 'manage', id));
      },
    }),
    []
  );

  return (
    <ContentGoldens
      generators={generatorsWithGoldens}
      stats={adminGoldensStats}
      callbacks={callbacks}
    />
  );
}

export default ContentGoldensContainer;
